import { Fragment, useEffect, useState } from 'react';
import MultiSelect from 'components/common/MultiSelectCheckbox/BinderV4Field';
import styles from './styles.scss';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FlatInput from 'components/common/Input/FlatInput';
import ErrorMessage from 'components/common/ErrorMessage';
import { datasourceOverrider, getStudyDetailFromOverride, getValue } from 'common/util/binderHelpers';
import { filter, get, isArray, isEmpty, map } from 'lodash';
import Select from 'react-select';
import InputField from 'components/common/Study/InputField/index';
import ChevronIcon from 'components/common/ChevronFaIcon';
import { customStylesV2 } from 'components/common/Dropdown/DropDownListHelper';
import DocumentDrivingDetailIcon from 'components/common/DocumentDrivingDetailIcon/index';
import { connect } from 'react-redux';

const SPONSOR = {
    label: 'Sponsor',
    name: 'sponsorCro'
};

const TRIAL_ID = {
    label: 'Protocol Number / Trial id',
    name: 'trialId'
};

function BasicInformation({
    binderTypes,
    canAddDataSource,
    onChange,
    studyStages,
    notValidFields,
    isStudyBinder,
    dataSources,
    overrides,
    isDelegationOfAuthorityOn,
    isEventOn,
    onDelegationCheck,
    handleEssetialsChange,
    handleDetailsChange,
    studyDetails,
    onEventCheck,
    study
}) {

    const customStylesV2WithPlaceholder = {
        ...customStylesV2,
        singleValue: (provided, state) => {
            const color = '#28282E';
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            return {
                ...provided, color, opacity, transition, padding: 0,
                fontWeight: '400',
                fontStyle: 'normal',
                fontFamily: 'Hind',
                'line-height': '20px',
                paddingTop: '4px'
            };
        },
        placeholder: (provided) => ({
            ...provided,
            fontFamily: 'Hind !important',
            fontSize: '16px !important',
            fontWeight: '400 !important',
            lineHeight: '23.59px !important',
            fontStyle: 'italic !important',
            color: '#B1B1B1 !important',
            paddingTop: '4px'
        })
    };

    const [sponsor, setSponsor] = useState({});
    const [protocol, setProtocol] = useState({});

    useEffect(() => {
        if (studyDetails.length && overrides && dataSources.length !== 0) {
            setProtocol(getStudyDetailFromOverride(TRIAL_ID.label, overrides, dataSources, studyDetails));
            setSponsor(getStudyDetailFromOverride(SPONSOR.label, overrides, dataSources, studyDetails));
        }

    }, [studyDetails, overrides, dataSources]);

    function handleProtocolOnChange(value) {
        if (protocol.isStudyDetails) {
            let val = '';
            if (isArray(value)) {
                val = [...value];
            } else {
                val = {
                    value: value.value ? value.value : value,
                    text: value.text ? value.text : value
                };
            }
            handleDetailsChange(protocol.descriptorId, val, TRIAL_ID.name);
        } else {
            handleEssetialsChange('trialId', `${value.value ? value.value : value}`, TRIAL_ID.name,);
        }
    }
    function handleSponsorChange(value) {
        if (sponsor.isStudyDetails) {
            let val = '';
            if (isArray(value)) {
                val = [...value];
            } else {
                val = {
                    value: value.value ? value.value : value,
                    text: value.text ? value.text : value
                };
            }
            handleDetailsChange(sponsor.descriptorId, val, SPONSOR.name);
        } else {
            handleEssetialsChange(SPONSOR.name, `${value.value ? value.value : value}`, SPONSOR.name);
        }
    }

    function getSelectValue(field) {
        const data = get(study, `${field}`, '');
        if (data) {
            data.data = data.name;
            data.label = data.name;
        }
        return data;
    }

    function showSponsorAndTrialId() {
        return (
            study &&
            study.fields &&
            study.fields.studyType &&
            !isEmpty(protocol) &&
            !isEmpty(sponsor)
        );
    }

    return (
        <Fragment>
            <p>Basic Information</p>
            <InputField
                required={true}
                label='Binder Type '
                htmlFor='binderType'
                customClasses={{
                    inputWrapper: styles.inputWrapper
                }}
            >
                <Select
                    id='binderType'
                    name='binderType'
                    placeholder="Select Binder Type"
                    options={binderTypes}
                    data-cy="add-binder-binder-type"
                    styles={customStylesV2WithPlaceholder}
                    value={getSelectValue('fields.studyType')}
                    onChange={(value) => onChange(value, 'studyType')}
                    className={notValidFields['studyType'] && styles.errorInput}
                    components={{
                        DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} />
                    }}
                />
            </InputField>
            {notValidFields['studyType'] && (<ErrorMessage text='Binder Type' />)}
            <div className={styles.Note}>
                <FontAwesomeIcon icon={faLock} />
                <p>Binder Type cannot change once the binder has been created.</p>
            </div>
            {
                showSponsorAndTrialId() && (
                    <Fragment>
                        <MultiSelect
                            label={sponsor.label || SPONSOR.label}
                            placeholder={sponsor.placeholder || `Select ${SPONSOR.label}`}
                            options={sponsor.options || []}
                            isRequired={isStudyBinder}
                            onSelectedOption={handleSponsorChange}
                            onChange={handleSponsorChange}
                            isSearchable={true}
                            value={getValue(SPONSOR.label, sponsor.isStudyDetails, study, sponsor.name)}
                            chipData={isArray(getValue(SPONSOR.label, sponsor.isStudyDetails, study, sponsor.name)) && getValue(SPONSOR.label, sponsor.isStudyDetails, study, sponsor.name)}
                            Tooltip={sponsor.isStudyDetails && DocumentDrivingDetailIcon}
                            isEmptyError={notValidFields[SPONSOR.name] && isStudyBinder}
                            canAddDataSource={canAddDataSource}
                            type={sponsor.inputFieldType}
                            showCreateField={sponsor.showCreateField}
                            datasourceId={sponsor.dataSourceId}
                            shouldBeAllValuesSelected={sponsor.shouldBeAllValuesSelected}
                            instructions={sponsor.instructions}
                            isStepOne={true}
                        />
                        {notValidFields[SPONSOR.name] && isStudyBinder && (<ErrorMessage text={datasourceOverrider(SPONSOR.label, overrides, dataSources, false)} />)}

                        <MultiSelect
                            label={protocol.label || TRIAL_ID.label}
                            placeholder={protocol.placeholder || `Select ${TRIAL_ID.label}`}
                            options={protocol.options || []}
                            isRequired={isStudyBinder}
                            onSelectedOption={handleProtocolOnChange}
                            onChange={handleProtocolOnChange}
                            isSearchable={true}
                            value={getValue(TRIAL_ID.label, protocol.isStudyDetails, study, protocol.name)}
                            chipData={isArray(getValue(TRIAL_ID.label, protocol.isStudyDetails, study, protocol.name)) && getValue(TRIAL_ID.label, protocol.isStudyDetails, study, protocol.name)}
                            Tooltip={protocol.isStudyDetails && DocumentDrivingDetailIcon}
                            isEmptyError={notValidFields[TRIAL_ID.name] && isStudyBinder}
                            canAddDataSource={canAddDataSource}
                            type={protocol.inputFieldType}
                            showCreateField={protocol.showCreateField}
                            datasourceId={protocol.dataSourceId}
                            isStepOne={true}
                            shouldBeAllValuesSelected={protocol.shouldBeAllValuesSelected}
                            instructions={protocol.instructions}
                        />
                        {notValidFields[TRIAL_ID.name] && isStudyBinder && (<ErrorMessage text={`${datasourceOverrider(TRIAL_ID.label, overrides, dataSources, TRIAL_ID.label)}`} />)}

                        <FlatInput
                            label="Binder Name"
                            placeholder="Enter Binder Name"
                            value={get(study, 'fields.studyName', '')}
                            isRequired={true}
                            onChange={(val) => onChange(val, 'studyName')}
                            notValid={notValidFields['studyName']}
                        />
                        {notValidFields['studyName'] && (<ErrorMessage text='Binder Name' />)}

                        <InputField
                            required={true}
                            label='Study Stage '
                            htmlFor='studyStage'
                            customClasses={{
                                inputWrapper: styles.inputWrapper
                            }}
                        >
                            <Select
                                id='studyStage'
                                name='studyStage'
                                placeholder="Select Study Stage"
                                options={studyStages}
                                value={getSelectValue('fields.studyStage')}
                                data-cy="add-binder-study-stage"
                                styles={customStylesV2WithPlaceholder}
                                onChange={(value) => onChange(value, 'studyStage')}
                                className={notValidFields['studyStage'] && styles.errorInput}
                                components={{
                                    DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} />
                                }}
                            />
                        </InputField>
                        {notValidFields['studyStage'] && (<ErrorMessage text='Study Stage' />)}
                        <div className={styles.delegationOfAuthorityContainer}>
                            <p>
                                <label className={styles.delegationOfAuthorityCheckboxLabel}>
                                    <input
                                        type="checkbox"
                                        checked={isEventOn}
                                        className={styles.delegationOfAuthorityCheckbox}
                                        onChange={({ target }) => onEventCheck(target.checked)}
                                    />
                                    Turn on Events
                                </label>
                            </p>
                        </div>
                        <div className={styles.delegationOfAuthorityContainer}>
                            <p>
                                <label className={styles.delegationOfAuthorityCheckboxLabel}>
                                    <input
                                        type="checkbox"
                                        checked={isDelegationOfAuthorityOn}
                                        className={styles.delegationOfAuthorityCheckbox}
                                        onChange={({ target }) => onDelegationCheck(target.checked)}
                                    />
                                    Turn on Delegation Of Authority
                                </label>
                            </p>
                        </div>
                    </Fragment>
                )
            }

        </Fragment>
    );
}

export default connect(
    (state, props) => {
        const study = get(state, 'study', {});
        const canAddDataSource = get(state, `me.institutionPermissions.${get(state, 'me.institution.id')}.dataSources`, false);
        const dataSources = filter(state.dataSources, ['institutionId', get(state, 'me.institution.id')]);
        const studyStages = map(get(state, 'study.studyStages', []), (stage) => ({ ...stage, value: stage.name, label: stage.name }));
        const binderTypes = map(get(state, 'study.usableStudyTypes', []), (type) => ({ ...type, value: type.name, label: type.name }));
        const selectedDatasourceOverrides = get(state, 'selectedDatasourceOverrides', []);
        const studyDetails = get(state, 'study.studyDetails', []);
        return {
            dataSources,
            canAddDataSource,
            studyStages,
            binderTypes,
            study,
            overrides: selectedDatasourceOverrides,
            studyDetails
        };
    },
    null
)(BasicInformation);